import '../../modules/mode-components';

import * as angular from 'angular';

import template from './switch-to-org-modal.html';

class SwitchToOrgModalController {}

const switchToOrgModalDirective = function (Modal) {
  return {
    restrict: 'A',
    scope: {
      account: '<',
      homeName: '@',
      currentContext: '=',
      connectDatabaseElementId: '<',
    },
    link: function ($scope: any, elem, attrs) {
      elem.on('click.switchToOrg', (event) => {
        const modal = Modal.open(
          {
            home: $scope.homeName,
            contextId: $scope.currentContext,
            account: $scope.account,
            connectDatabaseElementId: $scope.connectDatabaseElementId,
          },
          {
            controller: SwitchToOrgModalController,
            controllerAs: 'ctrl',
            bindToController: true,
            template: template,
          }
        );
      });

      // cleanup handlers
      $scope.$on('$destroy', () => elem.off('click.switchToOrg'));
    },
  };
};

switchToOrgModalDirective.$inject = ['ModalService'];

angular.module('mode.components').directive('switchToOrgModal', switchToOrgModalDirective);
